import React from "react";
import { 
    Level, LevelItem, Divider, Grid, GridItem, Tooltip, Icon
} from '@patternfly/react-core';
import ArrowCircleUpIcon from '@patternfly/react-icons/dist/esm/icons/arrow-circle-up-icon';
import ArrowCircleDownIcon from '@patternfly/react-icons/dist/esm/icons/arrow-circle-down-icon';

const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const VmOverview = ({
    vm,
    ovirtLoading
}) => {

  return (
    <>
    <Grid hasGutter>
        <GridItem span={3}>
            {vm?.icon_data ? (
                <img
                    src={`data:${vm.icon_data.media_type};base64,${vm.icon_data.base64}`}
                    alt="vm icon"
                />
            ) : (
                <div>No icon</div> // lub placeholder
            )}
        </GridItem>
        <GridItem span={9}>
            <Level>
                <LevelItem><small><b>VM:</b></small></LevelItem>
                <LevelItem>
                    {ovirtLoading ? "N/A" : vm.name}
                </LevelItem>
            </Level>
            <Level>
                <LevelItem><small><b>Pamięć:</b></small></LevelItem>
                <LevelItem>
                    {ovirtLoading ? "N/A" : formatBytes(vm.memory)}
                </LevelItem>
                <Divider/>
            </Level>
        </GridItem>
        <GridItem span={12}>
            <Level>
                <LevelItem><small><b>CPU:</b></small></LevelItem>
                <LevelItem>
                    {ovirtLoading ? "N/A" : `${vm.cpu.topology.cores} cores / ${vm.cpu.topology.sockets} sockets / ${vm.cpu.topology.threads} threads`}
                </LevelItem>
            </Level>
            <Level>
                <LevelItem><small><b>Status:</b></small></LevelItem>
                <LevelItem>
                    {ovirtLoading ? (
                    "N/A"
                    ) : (
                    <Tooltip content={<div>VM {vm.name}: {vm.status}</div>}>
                        <Icon status={vm.status === "up" ? "success" : "danger"}>
                            {vm.status === "up" ? <ArrowCircleUpIcon /> : <ArrowCircleDownIcon />}
                        </Icon>
                    </Tooltip>
                    )}
                </LevelItem>
                <Divider/>
            </Level>
        </GridItem>
    </Grid>
    </>
  );
};

export default VmOverview;